//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import FilterByTeam from '../components/UIElements/FilterByTeam'

const TeamSchedule = () => {
	console.log('inside TeamSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [teamId, setTeamId] = useState()
	const [leagueId, setLeagueId] = useState()
	const [wins, setWins] = useState()
	const [losses, setLosses] = useState()
	const [overtimeLosses, setOvertimeLosses] = useState()
	const [shootoutLosses, setShootoutLosses] = useState()
	const [ties, setTies] = useState()
	const [allTeamGames, setAllTeamGames] = useState([])
	const [allGameStats, setAllGameStats] = useState()

	const leagueName = useParams().leagueName
	const divisionName = useParams().divisionName
	const session = useParams().session
	const year = useParams().year
	const teamName = useParams().teamName

	console.log(
		'inside TeamSchedule.  divisionName is ' +
			divisionName +
			' and the leagueId is ' +
			leagueId,
	)
	//Get all games for a team WITHOUT a division.  getTeamSchedule2.  Also returns teamId.
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setAllTeamGames([])
			let response
			try {
				if (!divisionName) {
					response = await fetch(
						`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${leagueName}/${session}/${year}/${teamName}`,
					)
				} else {
					response = await fetch(
						`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${leagueName}/${divisionName}/${session}/${year}/${teamName}`,
					)
				}

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllTeamGames(responseData.allTeamGamesArray)
				setAllGameStats(responseData.allGameStatsArray)
				setTeamId(responseData.teamId)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setLeagueId(responseData.leagueId)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueName, session, year, teamName])
	//
	//
	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${months[game.date.substr(0, 2)]} ${game.date.substr(
			3,
			2,
		)}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const firstScore = Number(scoreParts[0])
		const secondScore = Number(scoreParts[1])

		if (Number.isNaN(firstScore) || Number.isNaN(secondScore)) {
			return game.score
		}

		/*
		Card layout is always:

		HOME TEAM | HOME SCORE - VISITOR SCORE | VISITOR TEAM
	*/

		if (game.winner === game.homeTeamId) {
			const homeScore = Math.max(firstScore, secondScore)
			const visitorScore = Math.min(firstScore, secondScore)

			return `${homeScore} - ${visitorScore}`
		}

		if (game.winner === game.visitorTeamId) {
			const homeScore = Math.min(firstScore, secondScore)
			const visitorScore = Math.max(firstScore, secondScore)

			return `${homeScore} - ${visitorScore}`
		}

		return `${firstScore} - ${secondScore}`
	}

	const getGameStatus = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.status === 'Shootout') {
			return 'SO'
		}

		if (game.status === 'Overtime') {
			return 'OT'
		}

		return 'FINAL'
	}
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}

	let dateBlock
	dateBlock = []
	if (!isLoading && allTeamGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				{/* <SearchByLeagueOrVenue /> */}
				<FilterByTeam leagueId={leagueId} divisionName={divisionName} />
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (
		!isLoading &&
		allTeamGames.length !== 0 &&
		allGameStats &&
		allGameStats.length > -1
	) {
		dateBlock.push(
			<div className='Schedule teamSchedulePage'>
				<div className='teamScheduleMobileHero'>
					<h1>{teamName}</h1>

					<h2>
						{allTeamGames[0].leagueName}
						{divisionName && ` - ${divisionName} Division`}
					</h2>

					<p className='teamScheduleMobileSeason'>
						{allTeamGames[0].session} {allTeamGames[0].year}
					</p>

					<div className='teamScheduleMobileDivider'></div>

					<div className='teamScheduleMobileRecordLabel'>Team Record</div>

					<div className='teamScheduleMobileRecord'>
						<div>
							<strong>{wins}</strong>
							<span>Wins</span>
						</div>

						<div>
							<strong>{losses}</strong>
							<span>Losses</span>
						</div>

						<div>
							<strong>{ties}</strong>
							<span>Ties</span>
						</div>

						<div>
							<strong>{overtimeLosses + shootoutLosses}</strong>
							<span>OTL/SOL</span>
						</div>
					</div>

					<div className='teamScheduleMobileDivider'></div>

					<div className='teamScheduleMobileFilter'>
						<FilterByTeam leagueId={leagueId} divisionName={divisionName} />
					</div>
				</div>

				<div className='teamScheduleDesktopInfo'>
					<h1>{teamName}</h1>

					<h5 className='h3Center'>
						{allTeamGames[0].leagueName +
							' ' +
							allTeamGames[0].session +
							' ' +
							allTeamGames[0].year}
					</h5>

					<h5 className='h3Center'>
						Record: {wins} - {losses} - {ties} -{' '}
						{overtimeLosses + shootoutLosses}
					</h5>

					<p className='clickOnThe'>
						(Click on the final score of a game to see a Game Summary)
					</p>
				</div>
				<table id='teamScheduleDisplay'>
					<thead>
						<tr>
							<th>Date/Time/Location</th>
							<th>Opponent</th>
							<th>Score</th>
							<th>Pts.</th>
						</tr>
					</thead>
					<tbody>
						{allTeamGames.map((game, key) => {
							// if (game.venueName === venue) {
							return (
								<tr key={key}>
									<td>
										{game.dayOfWeek}
										{', '}
										{game.date.substr(0, 2) === '01' &&
											'Jan. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '02' &&
											'Feb. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '03' &&
											'Mar. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '04' &&
											'Apr. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '05' &&
											'May ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '06' &&
											'June ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '07' &&
											'July ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '08' &&
											'Aug. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '09' &&
											'Sept. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '10' &&
											'Oct. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '11' &&
											'Nov. ' + game.date.substr(3, 2)}
										{game.date.substr(0, 2) === '12' &&
											'Dec. ' + game.date.substr(3, 2)}
										{/* </td>
									<td> */}
										{', '}
										{game.time.substr(0, 2) === '00' &&
											'12:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '01' &&
											'1:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '02' &&
											'2:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '03' &&
											'3:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '04' &&
											'4:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '05' &&
											'5:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '06' &&
											'6:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '07' &&
											'7:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '08' &&
											'8:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '09' &&
											'9:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '10' &&
											'10:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '11' &&
											'11:' + game.time.substr(3, 2) + ' am'}
										{game.time.substr(0, 2) === '12' &&
											'12:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '13' &&
											'1:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '14' &&
											'2:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '15' &&
											'3:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '16' &&
											'4:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '17' &&
											'5:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '18' &&
											'6:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '19' &&
											'7:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '20' &&
											'8:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '21' &&
											'9:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '22' &&
											'10:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '23' &&
											'11:' + game.time.substr(3, 2) + ' pm'}
										{game.time.substr(0, 2) === '24' &&
											'12:' + game.time.substr(3, 2) + ' am'}
										<br></br>
										{' @ '}
										<br></br>
										{game.venueName}
									</td>
									{game.homeTeamName === teamName && (
										<td>
											<Link
												style={{
													textDecoration: 'none',
													color: 'black',
													fontWeight: 600,
												}}
												to={`/league/schedule/${leagueName}/${session}/${year}/${game.visitorTeamName}`}
											>
												{game.visitorTeamName}
											</Link>
											{game.playoff && (
												<td style={{ color: 'red', fontWeight: 'bold' }}>
													{game.description}
												</td>
											)}
										</td>
									)}
									{game.visitorTeamName === teamName && (
										<td>
											<Link
												style={{
													textDecoration: 'none',
													color: 'black',
													fontWeight: 600,
												}}
												to={`/league/${leagueId}/${session}/${year}/${game.homeTeamName}`}
											>
												{game.homeTeamName}
											</Link>
											{game.playoff && (
												<div style={{ color: 'red', fontWeight: 'bold' }}>
													{'('}
													{game.description}
													{')'}
												</div>
											)}
										</td>
									)}
									{!game.score && <td></td>}
									{game.score && !game.winner && !game.loser && (
										<td style={{ color: 'black', fontWeight: 'bold' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'black',
												}}
												to={`/gameSummary/${game._id}`}
											>
												TIED {game.score}
											</Link>
										</td>
									)}
									{game.loser === teamId && (
										<td style={{ color: 'red', fontWeight: 'bold' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'red',
												}}
												to={`/gameSummary/${game._id}`}
											>
												LOST {game.score}
												{game.status === 'Overtime' && ' (OT)'}
												{game.status === 'Shootout' && ' (SO)'}
											</Link>
										</td>
									)}
									{game.winner === teamId && (
										<td style={{ color: 'green', fontWeight: 'bold' }}>
											<Link
												style={{
													textDecoration: 'none',
													fontWeight: 600,
													color: 'green',
												}}
												to={`/gameSummary/${game._id}`}
											>
												WON {game.score}
												{game.status === 'Overtime' && ' (OT)'}
												{game.status === 'Shootout' && ' (SO)'}
											</Link>
										</td>
									)}
									{game.homeTeamId === teamId && allGameStats[key] !== null && (
										<td>
											{JSON.stringify(allGameStats[key].homePointsAwarded)}
										</td>
									)}
									{game.visitorTeamId === teamId &&
										allGameStats[key] !== null && (
											<td>
												{JSON.stringify(allGameStats[key].visitorPointsAwarded)}
											</td>
										)}
									{allGameStats[key] === null && <td></td>}
								</tr>
							)
							//}
						})}
					</tbody>
				</table>
				<div className='scheduleCardsMobile teamScheduleCardsMobile'>
					{allTeamGames.map((game, key) => {
						return (
							<div
								className={`scheduleCard ${
									game.playoff || game.championship || game.description
										? 'scheduleCardSpecial'
										: ''
								}`}
								key={`team-mobile-${game._id || key}`}
							>
								<div className='scheduleCard__header'>
									<div>{formatGameDate(game)}</div>

									<div className='scheduleCard__league'>
										{game.playoff
											? 'PLAYOFF'
											: game.divisionName || game.leagueName}
									</div>

									<div>{formatGameTime(game)}</div>
								</div>

								<div className='scheduleCard__body'>
									<div className='scheduleCard__team'>
										{/* <span className='scheduleCard__teamLabel'>HOME</span> */}

										<span
											className={
												game.winner === game.homeTeamId
													? 'scheduleCard__winnerPill'
													: ''
											}
										>
											{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}
											{game.homeTeamName || 'TBD'}
										</span>
									</div>

									<div className='scheduleCard__scoreBox'>
										{game.score ? (
											<Link
												to={`/gameSummary/${game._id}`}
												className='scheduleCard__score'
											>
												{getDisplayScore(game)}
											</Link>
										) : (
											<div className='scheduleCard__score'>TBP</div>
										)}

										{game.score && (
											<div className='scheduleCard__status'>
												{getGameStatus(game)}
											</div>
										)}
									</div>

									<div className='scheduleCard__team'>
										{/* <span className='scheduleCard__teamLabel'>VISITOR</span> */}

										<span
											className={
												game.winner === game.visitorTeamId
													? 'scheduleCard__winnerPill'
													: ''
											}
										>
											{game.visitorTeamSeed > 0 && `(${game.visitorTeamSeed}) `}
											{game.visitorTeamName || 'TBD'}
										</span>
									</div>
								</div>

								<div className='scheduleCard__venue'>📍 {game.venueName}</div>

								{game.description && (
									<div className='scheduleCard__description'>
										{game.description}
									</div>
								)}

								{game.championship && (
									<div className='scheduleCard__description'>
										CHAMPIONSHIP GAME
									</div>
								)}
							</div>
						)
					})}
				</div>
			</div>,
		)
		// }
		//)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />
				{/* <SearchByLeagueOrVenue /> */}
				<div className='teamScheduleDesktopFilter'>
					<FilterByTeam leagueId={leagueId} divisionName={divisionName} />
				</div>
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default TeamSchedule
